import { failSilently } from '../../utils/failSilently';
import { sendGA4Event } from '../shared/sendGa4Event';
import type {
    FilterOffersEvent,
    FilterProductsEvent,
    OfferFilterCategoryType,
    ProductFilterCategoryType,
    SortProductsEvent,
    ZoomProductImageEvent,
} from './ga4Products';

const filterProducts = (categoryType: ProductFilterCategoryType, filters: string[]) => {
    const event: FilterProductsEvent = {
        event: 'filter',
        filter_category_1: categoryType,
        filter_category_2: filters.map((item) => item.toLowerCase()).join(','),
        event_key: 'filter_products',
    };

    sendGA4Event(event);
};

const filterOffers = (
    categoryType: OfferFilterCategoryType,
    selectedCategory: string | null = null,
) => {
    const event: FilterOffersEvent = {
        event: 'filter',
        filter_category_1: categoryType,
        filter_category_2: selectedCategory || 'no filter',
        event_key: 'filter_offers',
    };

    sendGA4Event(event);
};

const sortProducts = (sortingLabel: string) => {
    const event: SortProductsEvent = {
        event: 'filter',
        filter_category_1: 'sortering på',
        filter_category_2: sortingLabel.toLowerCase(),
        event_key: 'filter_products',
    };

    sendGA4Event(event);
};

const zoomProductImage = (open: boolean) => {
    const event: ZoomProductImageEvent = {
        event: 'zoom_product',
        event_action: open ? 'zoom open' : 'zoom close',
    };

    sendGA4Event(event);
};

export default {
    filterProducts: failSilently(filterProducts),
    filterOffers: failSilently(filterOffers),
    sort: failSilently(sortProducts),
    zoomImage: failSilently(zoomProductImage),
};
